'use strict';

var JSEncrypt = require('jsencrypt');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var JSEncrypt__default = /*#__PURE__*/_interopDefaultLegacy(JSEncrypt);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var RSA = /*#__PURE__*/function () {
  function RSA(options) {
    _classCallCheck(this, RSA);

    this.encrypter = new JSEncrypt__default['default']();
    this.rsaOptions = options;
  }

  _createClass(RSA, [{
    key: "encrypt",
    value: function encrypt(plainText) {
      this.encrypter.setPublicKey(this.rsaOptions.publicKey);
      return this.encrypter.encrypt(plainText) || 'plainText is empty string or encrypt error!';
    }
  }]);

  return RSA;
}();

var EncryptType;

(function (EncryptType) {
  EncryptType["RSA"] = "RSA";
  EncryptType["MD5"] = "MD5";
  EncryptType["SHA1"] = "SHA1";
})(EncryptType || (EncryptType = {}));

var instance;

var encryptFactory = function encryptFactory(encryptType, customOptions) {
  switch (encryptType) {
    case EncryptType.RSA:
      instance = new RSA(customOptions);
      break;

    default:
      return;
  }

  return instance;
};

module.exports = encryptFactory;
//# sourceMappingURL=index.cjs.js.map
